import { Route } from 'vue-router';
import { ElmFileDict } from 'frontend/types/lessons/editor';

export function moduleBaseName(route: Route): string {
  return route.params.lessonSlug
    .split('-')
    .map(s => (s.length ? s[0].toUpperCase() + s.substring(1) : ''))
    .join('');
}

export function mainModuleName(route: Route): string {
  return `Quiz${moduleBaseName(route)}Main`;
}

export function elmFilesForElmer(
  mainElm: string,
  additionalElm: ElmFileDict,
  route: Route,
): ElmFileDict {
  return {
    // Everything we want to send to Elmer goes here
    [mainModuleName(route)]: mainElm,
    ...additionalElm,
  };
}
